import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import { setupSentry } from "./sentry-setup";


// ----------------------------------------------------------------------
setupSentry();

const rootElement = document.getElementById('root') as HTMLElement

// // Workaround for https://bugs.webkit.org/show_bug.cgi?id=216681.
// rootElement.style.touchAction = "none";

const root = ReactDOM.createRoot(rootElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
